import React, { useState, useEffect } from "react";
import { generateClient } from "aws-amplify/data";
import AuthInterceptor from "../../interceptors/authInterceptor.jsx";
import Layout from "../../components/layout/AdminLayout.jsx";

const client = generateClient();

export default function MensajeAdmin() {
  const [quote, setQuote] = useState({ id: "", clave: "", valor: "" });
  const [author, setAuthor] = useState({ id: "", clave: "", valor: "" });
  const [mensajeId, setMensajeId] = useState(null);
  const [loading, setLoading] = useState(false);

  // Obtener el mensaje existente
  useEffect(() => {
    const fetchMensaje = async () => {
      try {
        const { data: items } = await client.models.Parametro.list({
          filter: {
            or: [{ clave: { eq: "quote" } }, { clave: { eq: "author" } }],
          },
        });

        const quoteParam = items.find((param) => param.clave === "quote");
        const authorParam = items.find((param) => param.clave === "author");

        if (quoteParam) setQuote(quoteParam);
        if (authorParam) setAuthor(authorParam);
      } catch (error) {
        console.error("Error al obtener el mensaje:", error);
      }
    };

    fetchMensaje();
  }, []);

  // Guardar o actualizar el mensaje
  const saveMensaje = async () => {
    setLoading(true);
    try {
      if (quote.id || author.id) {
        // Actualizar quote existente
        await client.models.Parametro.update({
          ...quote,
        });
        await client.models.Parametro.update({
          ...author,
        });
      } else {
        // Crear nuevo mensaje
        const { data: itemQuote } = await client.models.Parametro.create({
          clave: quote.clave || "quote",
          valor: quote.valor,
        });
        const { data: itemAuthor } = await client.models.Parametro.create({
          clave: author.clave || "author",
          valor: author.valor,
        });

        if (itemQuote) setQuote(itemQuote);
        if (itemAuthor) setAuthor(itemAuthor);
      }
    } catch (error) {
      console.error("Error al guardar el mensaje:", error);
      alert("Error al guardar el mensaje.");
    } finally {
      setLoading(false);
    }
  };

  const handlerQuote = (value) => {
    setQuote({
      ...quote,
      valor: value,
    });
  };

  const handlerAuthor = (value) => {
    setAuthor({
      ...author,
      valor: value,
    });
  };

  return (
    <Layout>
      <AuthInterceptor>
        <div className="p-4">
          <h2 className="mb-4 text-2xl font-bold">Administrar Mensaje</h2>

          {/* Contenido del Mensaje */}
          <div className="mb-4">
            <label className="mb-2 block">Mensaje:</label>
            <textarea
              value={quote.valor}
              onChange={(e) => handlerQuote(e.target.value)}
              className="w-full rounded border p-2"
              rows="3"
            />
          </div>

          {/* Autor del Mensaje */}
          <div className="mb-4">
            <label className="mb-2 block">Autor:</label>
            <input
              type="text"
              value={author.valor}
              onChange={(e) => handlerAuthor(e.target.value)}
              className="w-full rounded border p-2"
            />
          </div>

          {/* Guardar Cambios */}
          <button
            onClick={saveMensaje}
            className="rounded bg-green-500 px-4 py-2 text-white"
            disabled={loading}
          >
            {loading ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </AuthInterceptor>
    </Layout>
  );
}
